import styled from 'styled-components';

export const ImageWrapper = styled.div<{contentReverse: boolean}>`
    width: 100%;
    order: ${({ contentReverse }) => contentReverse ? 1 : 0};

    img, picture {
        display: block;
        height: auto;
        width: 100%;
    }
`;
